<template>
  <div class="core">
    <!-- <div class="layui-layer-title" style="cursor: move;"></div> -->
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="allForm" :showForm="true">
              <div class="layui-form">
                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单信息' : '服务请求工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <workOrder ref='workOrder' :editRow="formData"></workOrder>
                      <returnVisit ref='returnVisit' :editRow="formData"></returnVisit>
                    </layui-collapse>
                  </template>
                </pub-collapse>

                <pub-collapse 
                  :showHide="index == 0 ? true : false"
                  :title="(formData.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单信息' : '现场服务工程单信息') +item.SERVICE_ORDER_NUM"
                  v-for="(item, index) in formData['YW_SERVICE_ORDER_V1']" :key="index">
                  <template #content>
                    <layui-collapse>
                      <serviceOrder ref='serviceOrder' :editRow="item"></serviceOrder>
                      <signinout ref='signinout' :editRow="item"></signinout>
                      <selfCheck ref='selfCheck' :editRow="item"></selfCheck>
                      <acceptance ref='acceptance' :editRow="item"></acceptance>
                      <backorder ref='backorder' :editRow="item"></backorder>
                      <appraise ref='appraise' :editRow="item"></appraise>
                    </layui-collapse>
                  </template>
                </pub-collapse>
              </div>
              <div class="layui-form-btn">
                <div class="layui-footer">
                  <button class="layui-btn refresh" title="关闭" @click="close()">关 闭</button>
                </div>
              </div>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrder from './workOrderForm'
import returnVisit from './returnVisitForm'
import serviceOrder from './serviceOrderForm'
import signinout from './signInOutForm'
import selfCheck from './selfCheckForm'
import acceptance from './acceptanceForm'
import backorder from './backOrderForm'
import appraise from './appraiseForm'

export default {
  components: {
    workOrder,
    returnVisit,
    serviceOrder,
    signinout,
    selfCheck,
    acceptance,
    backorder,
    appraise
  },
  props: {
   
  },
  data () {
    return {
      formData: {

      }
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.formData
    }
    $(".core").animate({
          scrollTop: 0
    });
  },
  methods: {
   
    /**
     * 关闭
     */
    close() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
      if(this.tabParam.from == 'operLog'){
        this.baseComponent.loadComponentByName(this.tabParam.from);
      } else {
        this.baseComponent.loadComponentByName('viewBoard');
      }
    },
  }
}
</script>
<style scoped>
  /* .core .layui-form {
    padding: 10px 20px;
  } */
  .layui-layout-admin .layui-footer {
    left: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/workOrder/detailForm/allForm.vue